import { Component, Vue } from "vue-property-decorator";
import { InjectModule } from "@/decorators/InjectModule";
import Theme from "@/store/module/Theme";
import { NAV_TYPE_SIDE, NAV_TYPE_TOP } from "@/const/ThemeConstant";
import User from "@/store/module/User";
import Confirm from "@/store/module/Confirm";
import Loading from "@/store/module/Loading";

@Component
export default class Base extends Vue {
  @InjectModule(Theme)
  public theme$!: Theme;

  @InjectModule(User)
  public user$!: User;

  @InjectModule(Confirm)
  public confirm$!: Confirm;

  @InjectModule(Loading)
  public loading$!: Loading;

  public get isNavTop(): boolean {
    return this.theme$.navType === NAV_TYPE_TOP;
  }
  public get isNavSide(): boolean {
    return this.theme$.navType === NAV_TYPE_SIDE;
  }

  public openRequestFailAlert(): void {
    this.$message.error(
      "해당 요청을 처리하는데 문제가 발생했습니다.\n잠시 후에 다시 시도해주시기 바랍니다."
    );
  }
}
